import MyAccountChildProfileChangePlanModal from './MyAccountChildProfileChangePlanModal'

export default MyAccountChildProfileChangePlanModal
// eslint-disable-next-line import/export
export * from './MyAccountChildProfileChangePlanModal'
